/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

import {
  Wrapper,
  PreTitle,
  Text,
  Alert,
  SubTitle
} from '../components/ui';

import Visual from '../components/visual';
import TeamSelectorWrapper from '../components/team-selector-wrapper';

const getAlertNumber = (previousShownErrors) => {
  let num = Number(previousShownErrors);
  if (isNaN(num)) {
    num = 0;
  }

  return 1 + num;
}

const BannerLayout = ({
  section,
  subSection,
  previousShownErrors,
  alertText,
  subTitle,
  paragraph1,
  paragraph2,
  visual,
  visualProps = {},
  hideAlert = false,
  selectorOptions = null,
  onSelectorChange,
  selectorSelectedOptionId
}) => {
  return (
    <Wrapper>
      <PreTitle>{section}{subSection ? ` | ${subSection}` : ''}</PreTitle>
      {!hideAlert && <Alert><span>{getAlertNumber(previousShownErrors)}</span> {alertText}</Alert>}
      <SubTitle>{subTitle}</SubTitle>
      {paragraph1 && <Text>
        {paragraph1}
      </Text>}
      {selectorOptions && <TeamSelectorWrapper
        label={'View'}
        selectorOptions={selectorOptions}
        onSelectorChange={onSelectorChange}
        selectorSelectedOptionId={selectorSelectedOptionId}
      />}
      <Visual data={visual} {...visualProps} />
      {paragraph2 && <Text>
        {paragraph2}
      </Text>}
    </Wrapper>
  )
};

export default BannerLayout;



// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/layouts/banner.js